import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonDataService } from '../Common/common-data.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private commonData: CommonDataService) {}

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): boolean {
    const isSessionValid = sessionStorage.getItem('isLoggedIn') === 'true';
    const hasCollectionPoint = !!this.commonData.collectionpoint_id;
    const hasSocietyId = !!this.commonData.societyId;
    
    const isAuthenticated = isSessionValid && hasCollectionPoint && hasSocietyId;

    if (!isAuthenticated) {
      this.router.navigate(['/login'], { 
        queryParams: { returnUrl: state.url } 
      });
      return false;
    }

    return true;
  }
}
